import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavController } from '@ionic/angular';
import { Account } from '@jaimo-solutions-gmbh/platform-services-module';
import { getActiveStageName, stateSubject } from 'src/helpers';
import {
  faHome,
  faInfoCircle,
  faPeopleGroup,
} from '@fortawesome/free-solid-svg-icons';

import { faCompass } from '@fortawesome/free-regular-svg-icons';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {
  navItems = [
    {
      Key: 'main',
      Name: 'Startseite',
      Icon: faHome,
      Tooltip:
        'Hier siehst du nur die Neuigkeiten der Profile, denen du folgst.',
    },
    {
      Key: 'explore',
      Name: 'Entdecken',
      Icon: faCompass,
      Tooltip:
        'Hier kannst du Neuigkeiten von verschiedenen Profilen entdecken.',
    },
    {
      Key: 'followed',
      Name: 'Folge ich',
      Icon: faPeopleGroup,
      Tooltip: 'Hier findest du eine Auflistung der Profile, denen du folgst.',
    },
  ];

  infoIcon = faInfoCircle;
  currentYear = new Date().getFullYear();

  activeStageName: string;
  activeItem;

  constructor(
    private navCtrl: NavController,
    private title: Title,
    private router: Router
  ) {}

  ngOnInit() {
    stateSubject.subscribe(({ state }) => this.handleState(state));
  }

  goToStage(account: Account) {
    this.navCtrl.navigateForward('/' + account.handle, { animated: false });
  }

  updateTitle(item) {
    if (!item) return;

    let prefix;

    prefix = item.Name;
    if (prefix === 'Startseite') {
      prefix = 'Sicher informiert';
    } else if (prefix === 'Folge ich') {
      prefix = 'Folge ich';
    }

    this.title.setTitle(prefix + ' | Stage');
  }
  about() {
    window.open('https://about.stage.bio');
  }

  navigate = async (item, queryParams?) => {
    this.router.navigate([item.Key], { queryParams });
    this.activeItem = item;
  };

  private handleState(state) {
    this.activeItem = this.navItems.find((x) => x.Key === state);
    this.activeStageName = getActiveStageName();
    this.updateTitle(this.activeItem);
  }
}
